import Script from 'next/script'

import Layout from '@/components/Lending/Layout/Layout'
import PaymentLayout from '@/components/Payment/Layout/Layout'

import '@/styles/globals.css'
import '@/styles/FontAwesome.Pro.5/css/all.min.css'

export default function App({ Component, pageProps, ...appProps }) {
  const getContent = () => {
    // array of all the paths that doesn't need layout
    if (appProps.router.pathname.includes('/500')) {
      return <Component {...pageProps} />
    }
    if (appProps.router.pathname.includes('/thanh-toan')) {
      return (
        <>
          <Script id="KVA-script">
            {`window.kva=window.kva||function(){(kva.q = kva.q || []).push(arguments)}
        ;kva.l=+new Date;`}
          </Script>
          <Script only="thanh-toan" async src="/js/bootstrap.min.js" />
          <Script async src={process.env.NEXT_PUBLIC_REACT_APP_KVA_URL} />{' '}
          <PaymentLayout>
            <Component {...pageProps} />
          </PaymentLayout>
        </>
      )
    }
    return (
      <>
        <Script id="KVA-script">
          {`window.kva=window.kva||function(){(kva.q = kva.q || []).push(arguments)}
        ;kva.l=+new Date;`}
        </Script>
        <Script async src={process.env.NEXT_PUBLIC_REACT_APP_KVA_URL} />

        <Layout>
          <Component {...pageProps} />
        </Layout>
      </>
    )
  }
  return getContent()
}
